"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _command = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/command"));
var InsertSimpleBoxCommand = exports.default = /*#__PURE__*/function (_Command) {
  function InsertSimpleBoxCommand() {
    (0, _classCallCheck2.default)(this, InsertSimpleBoxCommand);
    return (0, _callSuper2.default)(this, InsertSimpleBoxCommand, arguments);
  }
  (0, _inherits2.default)(InsertSimpleBoxCommand, _Command);
  return (0, _createClass2.default)(InsertSimpleBoxCommand, [{
    key: "execute",
    value:
    // 执行命令会调这个函数
    function execute(uuid, fileName) {
      // this.editor.model.change(writer => {
      // 模型里面插入
      // 文档：https://ckeditor.com/docs/ckeditor5/latest/api/module_engine_model_model-Model.html

      // console.log('commond execute------')
      // this.editor.model.insertContent(createAttachmentBox(writer))

      // const attachmentBox = writer.createText(fileName, { uuid: uuid })
      // this.editor.model.insertContent(attachmentBox, this.editor.model.document.selection)
      // })
    }
    // 关于这个事件和上面事件或更多，查看文档：https://ckeditor.com/docs/ckeditor5/latest/api/module_engine_model_documentselection-DocumentSelection.html
  }, {
    key: "refresh",
    value: function refresh() {
      console.log('commond refresh------');
      var model = this.editor.model;
      var selection = model.document.selection;
      var allowedIn = model.schema.findAllowedParent(selection.getFirstPosition(), 'pdfBox');
      this.isEnabled = allowedIn !== null;
    }
  }]);
}(_command.default); // function createAttachmentBox(writer) {
//   const attachmentBox = writer.createElement('attachmentBox')
//   const attachmentIcon = writer.createElement('attachmentIcon')
//   const attachmentTitle = writer.createElement('attachmentTitle')
//   const attachmentUuBox = writer.createElement('attachmentUuBox')
//   writer.insertText('附件：', writer.createPositionAt(attachmentIcon, 0))
//   writer.insertText('title', writer.createPositionAt(attachmentTitle, 0))
//   writer.insertText('uuid', writer.createPositionAt(attachmentUuBox, 0))
//   writer.append(attachmentIcon, attachmentBox)
//   writer.append(attachmentUuBox, attachmentTitle)
//   writer.append(attachmentTitle, attachmentBox)
//   return attachmentBox
// }